export default "__VITE_ASSET__Ul9fbjJK__"